<template>
  <b-container fluid class="container-layout">
    <b-row align-h="center" class="mt-5">
      <p class="valida">Valida los siguientes datos para que puedas acceder a tus resultados</p>
    </b-row>
    <b-row align-h="center">
      <input
        :disabled="isDisabled"
        placeholder="Nombres"
        class="input-register"
        type="text"
        v-model="form.nombres"
      />
    </b-row>
    <b-row align-h="center">
      <input
        :disabled="isDisabled"
        placeholder="Apellidos"
        class="input-register"
        type="text"
        v-model="form.apellidos"
      />
    </b-row>
    <b-row align-h="center">
      <b-input
        :disabled="isDisabled"
        placeholder="Correo"
        class="input-register"
        type="text"
        :state="validateState('correo')"
        v-model="$v.form.correo.$model"
      />
    </b-row>
    <b-row align-h="center">
      <b-input
        :disabled="isDisabled"
        required
        placeholder="DNI"
        class="input2-register"
        type="text"
        :state="validateState('dni')"
        v-model="$v.form.dni.$model"
      />
      <b-input
        :disabled="isDisabled"
        placeholder="Celular"
        class="input2-register"
        type="text"
        :state="validateState('celular')"
        v-model="$v.form.celular.$model"
      />
        
    </b-row>
<b-row align-h="center">
    
          <p v-if="this.$v.form.$anyError" class="error-register mb-n5 mt-2">Faltan Campos por completar</p>
        
</b-row>
    <b-row align-h="center" class="mt-5">
      <button
        @click="isDisabled=!isDisabled"
        v-if="isDisabled"
        type="button"
        class="mt-3 mr-5 edit-button"
      >EDITAR</button>

      <button
        @click="confirmar()"
        v-if="isDisabled"
        type="button"
        class="mt-3 ml-5 confirm-button"
      >CONFIRMAR</button>
    </b-row>
    <b-row align-h="center" class="mt-5q">
      <button
        @click="actualizar()"
        v-if="!isDisabled"
        type="button"
        class="confirm-button"
      >Actualizar</button>
    </b-row>
    <b-modal
      no-close-on-backdrop
      v-model="modalUpdate"
      content-class="modal-finish"
      hide-footer
      ref="modal-confirm"
      hide-header-close
      centered
      size="md"
    >
      <b-row align-h="center" class="mt-2">
        <img src="@/assets/images/checkdatos.png" alt />
      </b-row>
      <b-row align-h="center" class="mt-4 confirm-act">
        <p>{{titulo}}</p>
      </b-row>
      <b-row align-h="center" class="mt-1 examen-finish2">
        <p>{{subtitulo}}</p>
      </b-row>

      <b-row align-h="center" class="mb-2 mt-4 ml-1">
        <button class="confirm-button" @click="accept()">ACEPTAR</button>
      </b-row>
    </b-modal>
    <b-modal hide-footer ref="modal-2" hide-header-close centered size="lg">
      <b-row>
        <p class="ml-4 mt-4 remember">Recuerda...</p>
      </b-row>

      <swiper
        @transitionStart="verificcarUltimo2()"
        @slideChangeTransitionStart="verificcarUltimo2()"
        ref="swiper2"
        class="swiper"
        :options="swiperOption"
      >
        <swiper-slide v-for="(items,key) in animacionesresultados" :key="key">
          <span class="animacion" v-html="items.animacion" />
        </swiper-slide>
        <div class="swiper-pagination bullet" slot="pagination"></div>
      </swiper>
      <b-row align-h="center">
        <button
          @click="Calificar()"
          type="button"
          class="mt-3 button-califica"
        >CALIFICA TU EXPERIENCIA</button>
      </b-row>
    </b-modal>
       <semipolar-spinner
    v-if="loaded"
    class="spinner"
  :animation-duration="2000"
  :size="80"
  color="#0F376E"
/>
  </b-container>
</template>

<script>

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { validationMixin } from "vuelidate";
import {
  email,
  required,
  numeric,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
   import { SemipolarSpinner  } from 'epic-spinners'

export default {
  name: "Edit",
  mixins: [validationMixin],
  components: {
    Swiper,
    SwiperSlide,
    SemipolarSpinner
  },
  data: () => ({
    loaded: false,
    titulo: "",
    subtitulo: "",
    modalUpdate2: false,
    isDisabled: true,
    modalUpdate: false,
    modal3: false,
    animacionesresultados: "",
    estudiante: "",
    form: {
      nombres: "",
      dni: "",
      celular: "",
      correo: "",
      id: "",
      apellidos: ""
    },
    swiperOption: {
      effect: "fade",
      speed: 1000,

      fadeEffect: {
        crossFade: true
      },
      slidesPerView: 1,
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true
      },
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      }
    }
  }),
  validations: {
    form: {
      correo: {
        email,
        required
      },
      celular: {
        required,
        numeric,
        minLength: minLength(9),
        maxLength: maxLength(9),
      },
      dni: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(9),
        numeric
      }
    }
  },
  created() {
    this.getAnimacionesResultados();
    this.estudiante = JSON.parse(localStorage.getItem("estudiante"));
    this.form = {
      nombres: localStorage.getItem("nombres"),
      apellidos: localStorage.getItem("apellido"),
      dni: this.estudiante.dni,
      celular: this.estudiante.celular,
      correo: this.estudiante.correo,
      id: this.estudiante.id
    };
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    Calificar() {
      this.$store.dispatch("setModulo", "Califica tu experiencia");
      this.$router.push("Calificar");
    },
    verificcarUltimo2() {
      if (this.swiper2.isEnd) {
        this.swiper2.autoplay.stop();
        this.modal3 = true;
      }
    },
    getAnimacionesResultados() {
      this.$store
        .dispatch(
          "getAnimacionesResultados",
          localStorage.getItem("id_simulacro")
        )
        .then(response => {
          this.animacionesresultados = response.data.animacion;
        })
        .catch(error => {
          console.log(error.message);
        });
    },
    accept() {
      if (!this.isDisabled) {
        this.modalUpdate = false;
        this.isDisabled = true;
      } else {
        this.modalUpdate = false;
        this.$refs["modal-2"].show();
      }
    },
    confirmar() {
      this.titulo = "DATOS VALIDADOS";
      this.subtitulo = "Tus datos fueron validados con exitó";
      this.modalUpdate = true;
    },
    actualizar() {
      this.loaded=true

      this.form.nombres = this.form.nombres + this.form.apellidos
      this.$store
        .dispatch("postActualizarEstudiante", this.form)
        .then(response => {
          if (response.data.estudiante) {
            this.titulo = "Actualizacion exitosa";
            this.subtitulo = "Tus datos fueron actualizados con exitó";
            this.modalUpdate = true;
             this.loaded=false
          }
        });
    }
  },
  computed: {
    swiper2() {
      return this.$refs.swiper2.$swiper;
    }
  }
};
</script>
<style scoped>
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 0px;
}
</style>